import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import view1 from '../assets/WEB 5.png';
import view2 from '../assets/WEB 8.png';

function Hero() {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate('/login');
  };

  return (
    <section id="hero" className="hero-section container">
      <h1 className="hero-title fade-up">
        Your One-Stop Business Solution.
      </h1>
      <p className="hero-subtitle fade-up">
        Stop juggling multiple tools. BOSS unifies invoicing, CRM, project management, payroll, and analytics
        in one affordable platform, designed for digital-first startups.
      </p>
      <button 
        className="primary-btn hero-cta fade-up" 
        onClick={handleCTAClick}
      >
        Start Your Free Trial
      </button>
      <div className="hero-trust fade-up">
        <p><strong>Trusted by 500+ digital entrepreneurs</strong></p>
      </div>
      <div className="hero-images-wrapper fade-up">
        <div className="hero-image-item">
          <img
            src={view1}
            alt="Dashboard view 1"
          />
        </div>
        <div className="hero-image-item hero-image-center">
          <img
            src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=700&q=80"
            alt="Dashboard view 2"
          />
        </div>
        <div className="hero-image-item">
          <img
            src={view2}
            alt="Dashboard view 3"
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;